// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"75017106","234":"cc433523","238":"8c631807","265":"55355d47","444":"695b220c","453":"fa2b4e6c","467":"6f245fd2","556":"b8da2aee","796":"97b44bb8","799":"2f806877","893":"f2ac8a05"}[chunkId] + ".chunk.js";
};